@if(!(CMService.hideHeader | async)){
<app-header></app-header>
}
<router-outlet />
<ngx-ui-loader bgsColor="#122589" fgsColor="#104cb0" fgsType="ball-spin-clockwise"></ngx-ui-loader>